import { groupBy } from 'lodash';

export function mapGroupedBy<T, U>(
  objects: Array<T>,
  key: string,
  block: (key: string, objects: Array<T>, index: number) => U,
) {
  const groups = groupBy(objects, key);

  return Object.keys(groups).map((key, index) =>
    block(key, groups[key], index),
  );
}

export function toArray<T>(value: T | null | Array<T>): Array<T> {
  if (value == null) {
    return [];
  }
  if (Array.isArray(value)) {
    return value;
  }
  return [value];
}
